import SEOHead from "@/components/feature/SEOHead";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import VideoGrid from "./components/VideoGrid";
import FeaturedSection from "./components/FeaturedSection";
import WhyUsSection from "./components/WhyUsSection";
import CTASection from "./components/CTASection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "樱花视频",
  url: "https://www.sakuramovie.com",
  description:
    "樱花视频为您提供91视频、97视频等数字品牌视频的免费高清在线观看，涵盖91在线视频完整内容，不缓冲不卡顿，畅享海量影视资源。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.sakuramovie.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="樱花视频 - 樱花视频91高清在线观看 | 91视频与97视频免费全集"
        description="樱花视频为您提供91视频、97视频等数字品牌视频的免费高清在线观看，涵盖91在线视频完整内容，不缓冲不卡顿，畅享海量影视资源。樱花视频,91视频,97视频,樱花视频91,91在线视频,数字视频网站,51视频,视频在线观看,高清免费,不缓冲全集"
        keywords="樱花视频,91视频,97视频,樱花视频91,91在线视频,数字视频网站,51视频,视频在线观看,高清免费,不缓冲全集"
        canonicalUrl="/"
        ogType="website"
        schemaData={homeSchema}
      />

      <HeroSection />
      <CategoryNav />
      <VideoGrid />
      <FeaturedSection />
      <WhyUsSection />
      <CTASection />
    </>
  );
}